import { create } from "zustand"

import type { AppModalType } from "../types"

interface AppModalsState {
  active: AppModalType | null
  queue: AppModalType[]
  open: (type: AppModalType) => void
  enqueue: (type: AppModalType) => void
  close: () => void
}

export const useAppModalsStore = create<AppModalsState>((set, get) => ({
  active: null,
  queue: [],

  open: (type) => {
    // Always a single modal — clear any stale queue so gift/event → chat
    // cannot surface a follow-up promo on close.
    set({ active: type, queue: [] })
  },

  enqueue: (type) => {
    const { active, queue } = get()
    if (active === type || queue.includes(type)) return
    if (!active) {
      set({ active: type })
      return
    }
    set({ queue: [...queue, type] })
  },

  close: () => {
    const { queue } = get()
    const [next, ...rest] = queue
    set({ active: next ?? null, queue: rest })
  },
}))

export function openAppModal(type: AppModalType) {
  useAppModalsStore.getState().open(type)
}

export function enqueueAppModal(type: AppModalType) {
  useAppModalsStore.getState().enqueue(type)
}

export function closeAppModal() {
  useAppModalsStore.getState().close()
}
